import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state,  UsersResource, Alert) {
        this.$state = $state;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }
    
     $onInit() {
        if (!this.notes.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
    }
    
     unshare() {
        const notesIds = this.notes
            .map(({id}) => id);

        this.isSaving = true;
        this.UsersResource
            .deleteUserSharedNotes(this.companyId, this.companyUser.id,notesIds)
            .then(() => {
                const companyAccounts = this.accountsForCompanyUser;
                const notes=this.userSharedNotes;
                const sharedAccounts= this.userSharedServiceAccounts;
                const filteredAccounts = notes.filter(({id}) => !notesIds.includes(id));
                notes.splice(0, notes.length, ...filteredAccounts);
                this.Alert('success', 'company.user-directories.manage-user.shared-notes.unshared');

                if (companyAccounts.length || filteredAccounts.length || sharedAccounts.lenght ) {
                    this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    this.$state.go('company.user-directories.saaspass-users');
                }
            })
            .finally(() => this.isSaving = false)
    }
    
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.controller.js